import React from 'react';
import styled from 'styled-components';
import { BusinessDisplayUnit } from '../../../types/business-group-type';
import DefaultBusinessIcon from '../../common/Icons/default-business-icon';

interface BusinessListUnitItemProps {
    businessDisplayUnit: BusinessDisplayUnit;
    onSelect: (businessDisplayUnit: BusinessDisplayUnit) => void;
}

const StyleBusinessListUnitItem = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    padding: 10px;
    padding-left: 20px;
    border-top: 1px solid #e4dee4;
    align-items: flex-start;
    cursor: pointer;
    .business-logo {
        max-width: 50px;
        max-height: 50px;
        align-self: center;
    }

    .business-description {
        height: 100%;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        margin-left: 20px;
    }

    .default-business-log {
        width: 50px;
        height: 50px;
    }

    .description {
        color: #787878;
    }

    .business-name {
        font-weight: bold;
    }
`;
const BusinessListUnitItem = ({ businessDisplayUnit, onSelect }: BusinessListUnitItemProps) => {
    return (
        <StyleBusinessListUnitItem
            onClick={(event) => {
                event.stopPropagation();
                onSelect(businessDisplayUnit);
            }}
            aria-label={businessDisplayUnit.name}
        >
            {businessDisplayUnit.photoURL ? (
                // eslint-disable-next-line jsx-a11y/alt-text
                <img className="business-logo" src={businessDisplayUnit.photoURL} />
            ) : (
                <DefaultBusinessIcon className="default-business-log" />
            )}

            <div className="business-description">
                <div className="business-name" aria-label={businessDisplayUnit.name}>{businessDisplayUnit.name}</div>
                <div className="description" aria-label={businessDisplayUnit.categoryName || businessDisplayUnit.categoryTags || ""}>
                    {businessDisplayUnit.categoryName
                        ? businessDisplayUnit.categoryName
                        : businessDisplayUnit.categoryTags}
                </div>
            </div>
        </StyleBusinessListUnitItem>
    );
};

export default BusinessListUnitItem;
